import * as signalR from '@microsoft/signalr';
import { devAuthUser, env } from '@config/env';
import { DEV_USER_HEADER } from '@core/api/client';

export interface HubClientOptions {
  getAccessToken: () => Promise<string | null>;
}

export function buildHubConnection(opts: HubClientOptions): signalR.HubConnection {
  const httpOptions: signalR.IHttpConnectionOptions = {};

  if (devAuthUser) {
    // Dev mode: force LongPolling because browsers cannot attach custom headers on the
    // WebSocket upgrade request — only LongPolling keeps X-Dev-User on every poll.
    httpOptions.transport = signalR.HttpTransportType.LongPolling;
    httpOptions.headers = { [DEV_USER_HEADER]: devAuthUser };
  } else {
    httpOptions.transport = signalR.HttpTransportType.WebSockets;
    // Skip the negotiate round-trip: with >1 API task behind the ALB, negotiate and the
    // follow-up connect can land on DIFFERENT tasks (per-connection state is task-local) and the
    // connect fails/retries. WebSockets is a single request, so skipping negotiate removes the
    // cross-task handshake entirely (scale-out step 3). Auth rides the access_token query param
    // (BE: JwtBearerSetup OnMessageReceived).
    httpOptions.skipNegotiation = true;
    httpOptions.accessTokenFactory = async () => (await opts.getAccessToken()) ?? '';
  }

  return new signalR.HubConnectionBuilder()
    .withUrl(`${env.apiBaseUrl}/hub/notifications`, httpOptions)
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Information)
    .build();
}
